<div class="content_container">

<div class="prizes-container">
  <div class="each-container">
      <h1>OPEN TOURNAMENT</h1>

      <div class="each-prize">
      <img src="assets/img/oppo-egypt/Asset%202.png" alt="1st Place">
          <h1>30 USD</h1>

      </div>
      <div class="each-prize">
        <img src="assets/img/oppo-egypt/Asset%201.png" alt="2nd Place">
        <h1>20 USD</h1>
      </div>

    </div>
    <div class="each-container">
      <h1>Elite TOURNAMENT</h1>
      <div class="each-prize">
      <img src="assets/img/oppo-egypt/Asset%202.png" alt="1st Place">
          <h1>650 USD</h1>

      </div>
      <div class="each-prize">
        <img src="assets/img/oppo-egypt/Asset%201.png" alt="2nd Place">
        <h1>350 USD</h1>
      </div>

  </div>
</div>


  </div>
